export const callAPI = async (
	endpoint: string,
	{
		method = 'GET',
		body,
		successCallback,
		errorCallback,
	}: {
		readonly method?: 'GET' | 'POST'
		readonly body?: BodyInit
		readonly successCallback?: (data: any) => void
		readonly errorCallback?: (error: any) => void
	}
) => {
	fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
		method: method,
		body: body,
		headers: new Headers({
			'accept': 'application/json, text/plain, */*',
			'content-type': 'application/json',
		}),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok')
			}
			return response.json()
		})
		.then((data) => {
			if ((data as any).errorMessage) {
				throw new Error((data as any).errorMessage)
			}

			successCallback?.(data)
		})
		.catch((error) => {
			console.error(error)
			errorCallback?.(error)
		})
}
